import reduceReducers from 'reduce-reducers';
import roadGraphGetShortest from '@modules/road-graph/route-test/reducers/get-shortest';
import roadGraphCleanRoute from '@modules/road-graph/route-test/reducers/clean-route';
import roadGraphForbiddenZones from '@modules/road-graph/route-test/reducers/get-forbidden-zones';
import roadGraphAddForbiddenZone from '@modules/road-graph/route-test/reducers/add-forbidden-zone';

const routeTestReducer = reduceReducers(roadGraphGetShortest, roadGraphCleanRoute, roadGraphForbiddenZones, roadGraphAddForbiddenZone);

export default routeTestReducer;
